import React from 'react'
import { isEmpty } from 'lodash-es'
import DefaultAvatarComponent from '../DefaultAvatarComponent/DefaultAvatarComponent'
import ImageComponent from '../ImageComponent/ImageComponent'

import './AvatarComponent.scss'

interface AvatarComponentProps {
  imageSrc: string
  name: string
  size: number | string
  imageProps: {}
  shape: 'circle' | 'square'
}

const AvatarComponent = ({
  imageSrc,
  name = '',
  size = 32,
  imageProps = {},
  shape = 'circle',
}: AvatarComponentProps) => {
  const backup = (
    <DefaultAvatarComponent identifier={name} width={size} height={size} />
  )

  return (
    <div
      className={`avatar-component shape-${shape}`}
      style={{ width: size, height: size }}
    >
      {isEmpty(imageSrc) ? (
        backup
      ) : (
        <ImageComponent
          src={imageSrc}
          alt={name}
          {...imageProps}
          backup={backup}
        />
      )}
    </div>
  )
}

AvatarComponent.displayName = 'AvatarComponent'

export default AvatarComponent
